import React, { useState, useEffect, useContext } from 'react';
import { Route, Routes, useNavigate, NavLink } from 'react-router-dom';

import { NavDropdown } from 'react-bootstrap';

import CostChangesHeader from './costChanges/costChangesHeader';
import ProductSales from './productSales/productSales';
import ProductSalesByInvoice from './productSalesByInvoice/productSalesByInoivce';
import IncomeStatement from './incomeStatement/incomeStatement';
import AllTransactions from './allTransactions/allTransactions';
import CashFlow from './cashFlow/cashFlow';


import { DataContext } from '../init/getData';
import { MdOutlineAccessTime } from "react-icons/md";
import { FcPackage, FcSurvey, FcSalesPerformance, FcApproval, FcDeployment, FcComboChart } from "react-icons/fc";
import { FaArrowRightArrowLeft } from "react-icons/fa6";
import { MdOutlineDiscount } from "react-icons/md";
import { TiArrowRepeatOutline } from "react-icons/ti";
import Session from './sessionLog/session/session';

function ReportTab(props) {

  const navigate = useNavigate();

  const { api, userData, settingData, menuPages } = useContext(DataContext);
  const userId = userData.id;
  const userName = userData.name;
  const userRole = userData.role;

  const [activeTab, setActiveTab] = useState('allTransactions');

  useEffect(() => {
    if (userRole.stockActivityPage) {
      navigate('/reportTab/allTransactions');
    }
  }, []);


  return (
    <div className="card" style={{ paddingTop: '0px', userSelect: 'none' }}>

      <div>

        {userRole.allTransactionsPage &&
          <NavLink to="allTransactions" onClick={() => setActiveTab('allTransactions')}>
            <div className={`${activeTab === 'allTransactions' ? 'tab-one active-link' : 'tab-one'}`} style={{ width: 'auto' }}>
              <FcComboChart size={35} />
              <span className="tab-text">{menuPages.AllTransactions}</span>
            </div>
          </NavLink>
        }

        {userRole.productSalesPage &&
          <div onClick={() => setActiveTab('productSales')} className={`${activeTab === 'productSales' ? 'tab-two active-link' : 'tab-two'}`}>
            <MdOutlineDiscount size={30} color={'#ffccbc'} />
            <NavDropdown title={<span className="navDropdown">{menuPages.ProductSales}</span>} >
              <NavDropdown.Item onClick={() => navigate("productSalesByItems")} style={{ color: 'white !important' }}>{menuPages.ByItems}</NavDropdown.Item>
              <NavDropdown.Item onClick={() => navigate("ProductSalesByInvoice")} style={{ color: 'white !important' }}>{menuPages.ByInvoice}</NavDropdown.Item>
            </NavDropdown>
          </div>
        }

        {userRole.cashFlowPage &&
          <NavLink to="cashFlow" onClick={() => setActiveTab('cashFlow')}>
            <div className={`${activeTab === 'cashFlow' ? 'tab-three active-link' : 'tab-three'}`} style={{ width: 'auto' }}>
              <TiArrowRepeatOutline size={33} />
              <span className="tab-text">{menuPages.CashFlow}</span>
            </div>
          </NavLink>
        }



        {userRole.incomeStatementPage &&
          <NavLink to="incomeStatement" onClick={() => setActiveTab('incomeStatement')}>
            <div className={`${activeTab === 'incomeStatement' ? 'tab-four active-link' : 'tab-four'}`} style={{ width: 'auto' }}>
              <FcSurvey size={28} />
              <span className="tab-text">Income Statement</span>
            </div>
          </NavLink>
        }

         <NavLink to="session" onClick={() => setActiveTab('session')}>
            <div className={`${activeTab === 'session' ? 'tab-five active-link' : 'tab-five'}`} style={{ width: 'auto' }}>
              <MdOutlineAccessTime  size={28} />
              <span className="tab-text">Session</span>
            </div>
          </NavLink>

      </div>


      <Routes>

        <Route path='costChanges' element={<CostChangesHeader />} />

        <Route path='productSalesByItems' element={<ProductSales type={'item'} />} />
        <Route path='ProductSalesByInvoice' element={<ProductSalesByInvoice />} />
        <Route path='allTransactions' element={<AllTransactions />} />
        <Route path='cashFlow' element={<CashFlow />} />
        <Route path='incomeStatement' element={<IncomeStatement />} />
        <Route path='session' element={<Session />} />

      </Routes>

    </div>
  );
}

export default ReportTab;
